// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2xHJk","fileBtn":"File_fileBtn__1K9kh","closeBtn":"File_closeBtn__1E_mN","fileSelected":"File_fileSelected__1ettu","disabled":"File_disabled__3mVIe"};